// extracted by mini-css-extract-plugin
var _1 = "page-content__mZigu";
export { _1 as "pageContent" }
